import './RelationPage.scss';

import { Button } from '@mui/material';
import { Relation, RelationFilters } from 'domain/relation/Relation';
import { RelationStatusEnum } from 'domain/relation/RelationStatusEnum';
import { RelationTypeEnum } from 'domain/relation/RelationTypeEnum';
import { InfiniteScroll } from 'primary/Components/InfiniteScroll/InfiniteScroll';
import { LeftRight } from 'primary/Components/Layout/LeftRight/LeftRight';
import { ListElements } from 'primary/Components/ListElements/ListElements';
import { UnpyTabs } from 'primary/Components/Tabs/UnpyTabs';
import { routesConfig } from 'primary/Configs/Routes.config';
import { useContextDependency } from 'primary/hooks/useContextDependency';
import { useFetchWithFilterPage } from 'primary/hooks/useFetchWithFilterPage';
import { useTranslate } from 'primary/hooks/useTranslate';
import { NoContentPreviewProfil } from 'primary/pages/myStructures/MyStructures.page';
import { WrapperFetchUserProfilCard } from 'primary/pages/profil/OtherUserProfilPage';
import { PreviewRelationUser } from 'primary/relation/PreviewRelationUser';
import React, { Dispatch, FC, SetStateAction, useState } from 'react';
import { useNavigate } from 'react-router-dom';

type RelationListProps = {
  type: 'BLOCKED' | 'FRIENDS' | 'WAITING';
  selectedFriend: Relation | null;
  setSelectedFriend: Dispatch<SetStateAction<Relation | null>>;
};

export const RelationList = ({
  type,
  selectedFriend,
  setSelectedFriend,
}: RelationListProps) => {
  const { authRepository, relationRepository } = useContextDependency();

  const { fetchedResource, setFilters, nextPage, loading, retry } =
    useFetchWithFilterPage<Relation, RelationFilters>({
      keyStoreFilters: 'relationsList-' + type,
      filters: {},
      staticFilters: {
        user: authRepository?.currentUser?.id,
        type:
          type === 'WAITING'
            ? RelationTypeEnum.FRIEND
            : type === 'FRIENDS'
            ? RelationTypeEnum.FRIEND
            : RelationTypeEnum.BLOCK,
        status:
          type === 'WAITING' ? RelationStatusEnum.PENDING : RelationStatusEnum.ACCEPTED,
      },
      callApi: (filters, page) =>
        relationRepository.searchFriendsOfUser(filters, page, 15),
      conditionFetch: (f) => !!authRepository?.currentUser && !!type,
    });

  return (
    <InfiniteScroll onScrollBottom={() => nextPage()} isLoading={loading}>
      {(scrollToTop) => (
        <ListElements loading={loading} empty={fetchedResource?.content.length === 0}>
          {!loading &&
            fetchedResource &&
            fetchedResource.content.map((relation) => (
              <PreviewRelationUser
                key={relation.id}
                onClick={(relation) => setSelectedFriend(relation)}
                isSelected={selectedFriend?.id === relation.id}
                relation={relation}
                type={type}
                retry={retry}
              />
            ))}
        </ListElements>
      )}
    </InfiniteScroll>
  );
};

export const RelationsPage: FC = () => {
  const [selectedFriend, setSelectedFriend] = useState<Relation | null>(null);
  const t = useTranslate();

  const navigate = useNavigate();

  const tabsConf = [
    {
      label: t(`relations.page.tabs.waiting`),
      component: (
        <RelationList
          setSelectedFriend={setSelectedFriend}
          selectedFriend={selectedFriend}
          key={'myRealtionPage-waiting'}
          type={'WAITING'}
        />
      ),
      to: routesConfig.relationPage.waitingList.to,
    },
    {
      label: t(`relations.page.tabs.friends`),
      component: (
        <RelationList
          setSelectedFriend={setSelectedFriend}
          selectedFriend={selectedFriend}
          key={'myRealtionPage-friends'}
          type={'FRIENDS'}
        />
      ),
      to: routesConfig.relationPage.friendsList.to,
    },
    {
      label: t(`relations.page.tabs.blocked`),
      component: (
        <RelationList
          setSelectedFriend={setSelectedFriend}
          selectedFriend={selectedFriend}
          key={'myRealtionPage-blocked'}
          type={'BLOCKED'}
        />
      ),
      to: routesConfig.relationPage.blockedList.to,
    },
  ];
  const { authRepository } = useContextDependency();

  if (!authRepository.currentUser) return null;

  const selectedFriendToDisplay =
    selectedFriend?.invited.id === authRepository.currentUser?.userProfil.id
      ? selectedFriend?.owner
      : selectedFriend?.invited;
  if (!authRepository.currentUser) return null;
  return (
    <div className={'myRelationsPage'}>
      <LeftRight
        sizeLeft={'big'}
        close={() => setSelectedFriend(null)}
        transparency={'opaq'}
        isOpen={!!selectedFriend}
        scrollInside
        left={
          <div className={'myRelationsPage__listRelations'}>
            <div className={'myRelationsPage__listRelations-header'}>
              <h3>{t('relations.page.title')}</h3>
              <Button
                variant={'contained'}
                onClick={() => navigate(routesConfig.mercatoSubPath.mercatoPlayer.path)}
                color={'primary'}
                type={'submit'}
                className={'-actionButton'}
              >
                {t('relations.page.buttonAddFriend')}
              </Button>
            </div>
            <div className={'myRelationsPage__listRelations-list'}>
              <UnpyTabs tabsConf={tabsConf} center fullHeight />
            </div>
          </div>
        }
        right={
          <>
            {selectedFriendToDisplay?.idProfil && (
              <div
                className={'-containerProfil --scrollBarContent'}
                key={selectedFriendToDisplay?.idProfil}
              >
                <WrapperFetchUserProfilCard
                  id={selectedFriendToDisplay?.idProfil}
                  key={selectedFriendToDisplay?.idProfil}
                />
              </div>
            )}
            {!selectedFriendToDisplay?.idProfil && (
              <NoContentPreviewProfil type={'userProfil'} />
            )}
          </>
        }
      />
    </div>
  );
};

//
// export const RelationsPage: FC = () => {
//   const { authRepository, relationRepository } = useContextDependency();
//   const t = useTranslate();
//   const user = useSelector((state: RootState) => state.user.connectedUser);
//
//   const { fetchedResource, goToPage, loading } = useFetchWithFilterPage<
//     Relation,
//     RelationFilters
//   >({
//     filters: { user: user?.id },
//     callApi: (filters, page) =>
//       relationRepository.searchFriendsOfUser(filters.user as number, page, 32),
//   });
//
//   if (!authRepository.currentUser) return null;
//
//   return (
//     <div className={'relationPage'}>
//       <LayoutPageList title={t('relation.page.list.title')} background={Background}>
//         <div className={'relationPage__listContainer'}>
//           <div className={'relationPage__listContainer-header'}>
//             <Pagination
//               key={fetchedResource?.currentPage}
//               size={'medium'}
//               count={fetchedResource?.pagesCount}
//               page={
//                 fetchedResource?.currentPage
//                   ? fetchedResource?.currentPage + 1
//                   : undefined
//               }
//               onChange={(e, value) => goToPage(value - 1)}
//             />
//             {loading && <CircularProgress />}
//           </div>
//           <div className={'relationPage__content'}>
//             {fetchedResource?.content.map((relation) => {
//               return <PreviewRelationUser relation={relation} />;
//             })}
//             {!fetchedResource?.content ||
//               (fetchedResource.content && fetchedResource.content.length == 0 && (
//                 <div className={'myMessagePage__conversations-noContent'}>
//                   <span>{t('message.conversation.noContent')}</span>
//                 </div>
//               ))}
//           </div>
//         </div>
//       </LayoutPageList>
//     </div>
//   );
// };
